import { createApi as e } from "../../../node_modules/@reduxjs/toolkit/dist/query/react/rtk-query-react.modern.js";
import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK as s } from "../constants.js";
const r = ({ baseUrl: r2, baseQuery: o }) => {
  const t = e({ reducerPath: "seasonTypesApi", baseQuery: o({ baseUrl: `${r2}/season-types` }), keepUnusedDataFor: s, endpoints: (e2) => ({ getSeasonTypes: e2.query({ query: () => ({ url: "/" }) }) }) }), { useGetSeasonTypesQuery: a } = t;
  return { seasonTypesApi: t, useGetSeasonTypesQuery: a };
};
export {
  r as initializeSeasonTypesApi
};
//# sourceMappingURL=seasonTypesApi.js.map
